import { UrlObject } from 'url';

export function serializeUrlObject(href: UrlObject): string {
  const searchParams = new URLSearchParams();

  if (href.query && typeof href.query !== 'string') {
    Object.entries(href.query).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((item) => {
          if (item !== undefined && item !== null) {
            searchParams.append(key, String(item));
          }
        });
      } else if (value !== undefined && value !== null) {
        searchParams.set(key, String(value));
      }
    });
  }

  const queryString = searchParams.toString();

  return `${href.pathname || ''}${queryString ? `?${queryString}` : ''}${
    href.hash || ''
  }`;
}
